/* eslint-disable no-undef */

import { ENVIRONMENT } from "./common/constants";

const PROD = {
	baseName: "/self-kyc",
	baseUrl: "https://digi-api.airtel.in",
	ecafCommonsBaseUrl: "https://digi-api.airtel.in/ecaf-commons",
	ecafMediaBaseUrl: "https://digi-api.airtel.in/media-service"
};

const PRE_PROD = {
	baseName: "/longurl/self-kyc",
	baseUrl: "https://kongqa.airtel.com/web",
	ecafCommonsBaseUrl: "https://kongqa.airtel.com/ecaf-commons-beta",
	ecafMediaBaseUrl: "https://kongqa.airtel.com/media-service-beta"
};

const STAGE = {
	baseName: "/longurl/self-kyc",
	baseUrl: "https://kongqa.airtel.com/web",
	ecafCommonsBaseUrl: "https://kongqa.airtel.com/ecaf-commons-beta",
	ecafMediaBaseUrl: "https://kongqa.airtel.com/media-service-beta"
};

const DEV = {
	baseName: "/longurl/self-kyc",
	baseUrl: "https://kongqa.airtel.com/web",
	ecafCommonsBaseUrl: "https://kongqa.airtel.com/ecaf-commons-beta",
	ecafMediaBaseUrl: "https://kongqa.airtel.com/media-service-beta"
};

class ENV {
	env;
	envName;
	constructor() {
		this.envName = ENVIRONMENT.DEV;
		this.env = DEV;
		if (process.env.REACT_APP_ENV === ENVIRONMENT.PROD) {
			this.env = PROD;
			this.envName = ENVIRONMENT.PROD;
		} else if (process.env.REACT_APP_ENV === ENVIRONMENT.STAGE) {
			this.env = STAGE;
			this.envName = ENVIRONMENT.STAGE;
		} else if (process.env.REACT_APP_ENV === ENVIRONMENT.PRE_PROD) {
			this.env = PRE_PROD;
			this.envName = ENVIRONMENT.PRE_PROD;
		}
	}

	getAppUrl() {
		return;
	}

	getBaseUrl() {
		return this.env.baseUrl;
	}

	getEcafCommonsBaseUrl() {
		return this.env.ecafCommonsBaseUrl;
	}

	getEcafMediaBaseUrl() {
		return this.env.ecafMediaBaseUrl;
	}

	getBaseName() {
		return this.env.baseName;
	}

	getEnvironment() {
		return this.envName;
	}
}

const instance = new ENV();
Object.freeze(instance);

export default instance;